import { firebase, disconnectDb } from 'app-modules/application/utils/firebase';
import { LOAD_LEADERBOARD } from './types';
import { triviaFetchRankingPositionActionThunk } from './fetchRankingPosition';

const fetchUserData = async (db, userScore) => {
  const userId = userScore.key;
  const points = userScore.val();

  let chatName = 'No name';
  try {
    const userDataSnapshot = await db.ref(`/users/${userId}`).once('value');
    if (userDataSnapshot.exists()) {
      ({ chatName } = userDataSnapshot.val());
    }
  } catch (err) {
    // do nothing
  }

  return {
    userId,
    chatName,
    points,
  };
};

export const triviaLoadLeaderboardThunkAction = (quantity = 5) => async (dispatch) => {
  try {
    const db = firebase.database();
    db.goOnline();

    await dispatch(triviaFetchRankingPositionActionThunk());

    const scoresSnapshot = await db
      .ref('/scores')
      .limitToLast(quantity)
      .orderByValue()
      .once('value');
    if (scoresSnapshot.exists()) {
      const leaderBoardData = [];
      scoresSnapshot.forEach((item) => {
        leaderBoardData.push(fetchUserData(db, item));
      });

      const leaderBoard = await Promise.all(leaderBoardData);
      leaderBoard.reverse();

      dispatch({ type: LOAD_LEADERBOARD, payload: { leaderBoard } });
    }
  } catch (err) {
    dispatch({ type: LOAD_LEADERBOARD, error: true, payload: err });
  } finally {
    disconnectDb();
  }
};
